import { render, staticRenderFns } from "./CustomersFilter.vue?vue&type=template&id=a72fcc4c&"
import script from "./CustomersFilter.vue?vue&type=script&lang=js&"
export * from "./CustomersFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports